import React from 'react'
import { SelectInput, ReferenceInput, TextInput } from 'react-admin'
import { EditGuesser } from 'theme/components'

export const CountryEdit = (props) => (
  <EditGuesser {...props} undoable={false} variant="outlined" redirect="list">
    <TextInput source="name" />
    <TextInput source="code" />
    <ReferenceInput
      source="cluster"
      reference="clusters"
      format={(v) => (v && v['@id'] ? v['@id'] : v)}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </EditGuesser>
)
